import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Lang } from '../Lang/MainLang';
import logo from '../assets/luxWhite.svg';
import { ControllNav } from './Functions/ControllNav';
import { Garanty } from './Scomp/Garanty';

const Styles = styled.div`
    width: 100%;
    position: relative;
    direction: ${Lang.direction};
    display: flex;
    flex-direction: column;
    margin-top: 2rem;
    .footer-garanty{
        display: flex;
        flex-direction: row;
        padding:2.5rem var(--padding) 1rem;
        width: calc(100% - var(--width-padding));
        margin-bottom: 1rem;
        .garant{
            .garanty-svg{
                width: 3rem;
            }
            .garanty-tit{
                font-size: 1.25rem;
            }
            .garanty-desc{
                font-size: 1rem;
            }
        }
    }
    .bottom-footer{
        position: relative;
        bottom: 0;
        padding:0 var(--padding) 1rem;
        background: var(--gray-14);
        width: calc(100% - var(--width-padding));
        display: grid;
        grid-template-columns: 30% 40% 30%;
        .goto-top{
            /* z-index: 200; */
            display: none;
            position: absolute;
            top: -1.5rem;
            width: 4rem;
            height: 4rem;
            border-radius: 50%;
            right: calc(50% - 2rem);
            text-align: center;
            font-size: 3rem;
            background-color:var(--primary-7);
            cursor: pointer;
            color: var(--body-2);
            svg{
                width: 35%;
                fill: var(--body-2);
                transform: rotate(-90deg);
                display: flex;
                align-items: baseline;
                margin: 0.5rem auto;
            }
        }
        .logo{
            z-index: 110;
            width: 4.5rem;
            height: 4.5rem;
            display: none;
            flex-direction: row;
            justify-content: center;
            background-color: var(--primary-1);
            border-radius: 50%;
            position: absolute;
            top: -2.25rem;
            right: calc(50% - 2.25rem);
            img{
                width: 80%;
                fill: var(--body-1);
            }  
        }
        
        .media-footer-mo{
            display: none;
        }
        .left-container , .right-container{
            margin-bottom: 1rem;
            display: flex;
            width: 100%;
            max-width: fit-content;
            flex-direction: column;
            justify-content: right;
            .lux-logo{
                width: 40%;
                margin: 2.5rem 0 1rem;
            }
            .lux-desc{
                font-size: 1rem;
                font-weight: 500;
                color: var(--text-3);
                text-align: justify;
            }
            .media-footer{
                text-align: center;
                color: var(--text-1);
                font-size: var(--fs-copyright);
                font-weight: 300;
                display: flex;
                flex-direction: row-reverse;
                justify-content: center;
                margin: 2.5rem auto 1rem 0;
                align-items: center;
                 .icon {
                    margin-right: 0.5rem;
                    width: 1.5rem;
                    height: 1.5rem;
                    padding: 0.5rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    color: #818796;
                    fill: #818796;
                    cursor: pointer;
                    align-items: center;
                    text-decoration: none;
                    background: var(--gray-10);
                    border: 1px solid var(--gray-7);
                    border-radius: var(--border-radius-2);
                }
            }
            .bottom-container{
                margin-top: 1rem;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                width: 100%;
                .enamad {
                    width: 7vh;
                    height: 7vh;
                    border-radius: 10px;
                    padding: 0.5rem;
                    /* border: 1px solid var(--text-1);
                    background-color: var(--body-1); */
                    margin-left: 1rem;
                    position: relative;
                    img{
                        width: 100%;
                        height: 100%;
                        object-fit: scale-down;
                    }
                }
            .samandehi {
                width: 7vh;
                height: 7vh;
                border-radius: 10px;
                padding: 0.5rem;
                /* border: 1px solid var(--text-1);
                background-color: var(--body-1); */
                position: relative;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: scale-down;
                }
           }
            .copyright{
                position: relative;
                margin-top: 6rem;
                display: none;
                justify-content: center;
                font-size: var(--fs-copyright);
                font-weight: 400;
                margin: auto;
                color: var(--text-3);
                text-align: center;
            }
        }
        }
        .left-container {
            justify-self: flex-end;
        }
        .midd-container{
            display: flex;
            flex-direction: row;
            justify-content: center;
            padding-top: 4rem;
            .right-link, .left-link{
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                margin: 0 2.5rem;
                .link{
                    margin: 0.5rem 0;
                    text-decoration: none;
                    color: var(--gray-6);
                    font-size: 1rem;
                    font-weight: 400;
                    /* transition: all 3ms ease-in-out; */
                    :hover{
                        color: var(--text-3);
                        /* margin-right: 0.5rem; */
                        /* transition: all 3ms ease-in-out; */
                    }
                    .icon{
                        font-size: 0.5rem;
                        margin: 0 0.3rem;
                    }
                }
            }
        }
    }
    
          
    @media screen and (max-width: 850px) {      
        .footer-garanty{
            display: grid;
            grid-template-columns: repeat(2 , 50%);
            grid-row-gap: 1rem ;
            margin-bottom: 1rem;
            .garant{
                .garanty-svg{
                    width: 2.5rem;
                }
                .garanty-tit{
                    font-size: 1rem;
                }
                .garanty-desc{
                    font-size: 0.87rem;
                }
                :first-child{
                    border-left: none;
                }
                :nth-child(odd){
                    border-left: none;
                }
                :nth-child(even){
                    border-left: var(--border-style-2);
                }
            }
        }  
        .bottom-footer{
            grid-template-columns: 1fr;
            .goto-top{
                top: -1.5rem;
                width: 3.5rem;
                height: 3.5rem;
                right: calc(50% - 1.75rem);
            }
            .logo{
                width: 3.5rem;
                height: 3.5rem;
                bottom: 1rem;
                right: calc(50% - 1.75rem); 
            }
            
            .right-container, .left-container{
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .media-footer {
                    margin:1rem auto 0.5rem;
                    .icon{
                        width: 1rem;
                        height: 1rem;
                    }
                }
                .right-link , .left-link{
                    .link {
                        line-height: 37px;
                        :hover{
                            margin: 0.5rem 0
                        }
                    }
                }
                .bottom-container{
                    margin-top: 0;
                    .link{
                        display: flex;
                        align-items: center;
                        font-weight: 300;
                    }
                    .icon {
                        width: 1.2rem;
                    }
                    .logos{
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        .enamad ,
                        .samandehi{
                            width: 5rem;
                            height: 3rem;
                            position: relative;
                            margin: 3rem 0.25rem;
                        }                
                    }
                } 
            }
            .left-container{
                flex-direction: row;
                align-items: flex-end;
                margin-bottom: 2rem;
                overflow: hidden;
            }
            .midd-container{
                padding-top: 0 ;
                padding: 0 ;
                .right-link , .left-link{
                    margin: 0 0;
                    flex-grow: 1;
                }
            }
            .media-footer-mo{
                width: 100%;
                text-align: center;
                color: var(--text-1);
                font-size: var(--fs-copyright);
                font-weight: 300;
                display: flex;
                flex-direction: row-reverse;
                align-items: center;
                justify-content: center;
                margin: 3rem auto 0 ;
                .icon {
                    margin: 0 auto;
                    width: var(--fs-icons);
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    color: var(--body-2);
                    fill: var(--body-2);
                    cursor: pointer;
                    
                }
            }
          
        }    
    }

    @media screen and (max-width: 380px) {  
        .bottom-footer{
            .left-container{
                flex-wrap: wrap;
                margin-left: auto;
                margin-right: auto;
            }
        }
    }
`;
class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ShowProfile: false,
            navActive: false,
        }; 
    }
    componentDidMount() { 
        this._ismounted = true;
    }
    componentWillUnmount() {
        this._ismounted = false;
    }
    scrollToTop = (e) => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }
    butoomFooter=()=>{
        if(window.innerWidth < 850){
            return(
                <div className="bottom-container container">
                        <div className='logos'>                            
                            <div className="samandehi">
                                <img referrerPolicy='origin' id ='rgvjwlaojxlzjzpeesgtfukz' style ={{cursor:'pointer'}} onClick={() => window.open("https://logo.samandehi.ir/Verify.aspx?id=341706&p=xlaoaodsrfthjyoeobpdgvka", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")} alt='logo-samandehi' src='https://logo.samandehi.ir/logo.aspx?id=341706&p=qftishwlnbpdyndtlymawlbq'/>
                            </div>
                            <div className="enamad">
                                    {/* eslint-disable */}
                                <a referrerPolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=316755&amp;Code=l2OpzRrnLXs24hv0lDf9"><img referrerPolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=316755&amp;Code=l2OpzRrnLXs24hv0lDf9" alt="" style={{cursor:'pointer'}} id="l2OpzRrnLXs24hv0lDf9"/></a>
                            </div>
                        </div>
                        <div className='copyright'>
                            {Lang.Footer.copyRight}
                        </div>
                    </div>
            )
        }
    }
    render() {
        if(this.props.location.pathname !== "/" && !ControllNav(this.props.location.pathname)){
            return "";
        }
        let path1=this.props.location.pathname.split('/')[1]
        let path2=this.props.location.pathname.split('/')[2]
        let path3=this.props.location.pathname.split('/')[3]
        let path5=this.props.location.pathname.split('/')[5]
        let responseBuying =(( path1 === 'buying' || (path2 === 'orders' && path5 === undefined) || (path3 === 'new') || (path1 === 'good')) && (window.innerWidth < 850))
        if((path1 === 'good')){
            responseBuying = true
        }
        return (
            <Styles>
                <Garanty classname={'footer-garanty'} title='چرا لوکسین لوکس ؟'/>
                <div className="bottom-footer" style={{minHeight:(responseBuying ? 'calc(33vh + 55px)':'')}} >
                    <div className="goto-top" onClick={this.scrollToTop}>
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 150 150">
                        <title>arrows-footer</title>
                        <path className="st0" d="M37.5,8.1c0,1.9,0.8,3.7,2.2,5.1l55.2,52.1c4.7,4.4,4.9,11.8,0.5,16.4l-52.1,55.2c-2.8,2.7-2.9,7.1-0.2,9.9
                            c2.7,2.8,7.1,2.9,9.9,0.2c0.2-0.1,0.3-0.3,0.4-0.5l52.1-55.2c4.7-4.9,7.2-11.5,7-18.3c-0.2-6.8-3.1-13.2-8-17.9L49.3,3
                            c-2.8-2.6-7.2-2.5-9.9,0.3C38.2,4.6,37.5,6.3,37.5,8.1z"/>
                        </svg>
                    </div>
                    <div className="logo" onClick={this.scrollToTop}>
                        {/* <img src={Logo} alt="hyperbg-logo"/> */}
                    </div>
                    
                    <div className="right-container container">       
                        <img src={logo} alt='لوکسین‌لوکس' className='lux-logo'/>
                        <div  className='lux-desc'>
                            ما در لوکسین لوکس به دنبال ارائه تجربه خرید لوکسی بی‌نظیر به شما عزیزان هستیم، در پلتفرمی که مملو از محصولات استثنایی است؛ محصولاتی که در کیفیت و ظرافت بی‌همتا هستد.
                        </div>
                       
                    </div>
                    <div className="midd-container container">
                        <div className='right-link'>
                            <Link to='/aboutus/' className='link'> {Lang.Footer.aboutUs}</Link>
                            <Link to='/contactus/' className='link'> {Lang.Footer.contactUs}</Link>
                            <Link to='/questions/' className='link'> {Lang.Footer.faq}</Link>
                            <a href={process.env.REACT_APP_MAIN +'/blog/'} className=' link'> {Lang.Footer.blog}</a>
                            <Link to='/campaign/discover-luxury/' className='link'> {Lang.Footer.discover_luxury}</Link>
                        </div>    

                       
                        <div className='left-link'>
                            <Link to='/rules/' className='link'>{Lang.Footer.rules} </Link>
                            <Link to='/shops/'  className='link'> {Lang.Footer.shops}</Link>
                            <Link className=' link ' to={'/singup-seller/'}>
                                {Lang.Footer.shopRequest}    
                            </Link>
                            <Link to='/campaign/luxgardi/' className='link'>{Lang.Footer.luxgardi} </Link>
                        </div>
                    </div>  
                    <div className="left-container container" style={{marginBottom: (responseBuying) ? "80px" : "2rem"}}>
                        <div className='media-footer'>
                            <a href='https://www.instagram.com/luxinlux_com/' className="icon" target="_blank" >
                                <svg version="1.1" style={{width: '80%', margin: 'auto'}} baseProfile="basic" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 240 240">
                                    <title>instagram</title>
                                    <path className="st0" d="M183.4,43.3c-7.7,0-14,6.3-14,14s6.3,14,14,14s14-6.3,14-14S191.2,43.3,183.4,43.3z"/>
                                    <path className="st0" d="M121,61.3c-32.6,0-59,26.4-59,59s26.4,59,59,59s59-26.4,59-59C179.9,87.7,153.6,61.4,121,61.3z M121,158.1
                                        c-20.9,0-37.8-16.9-37.8-37.8s16.9-37.8,37.8-37.8s37.8,16.9,37.8,37.8v0C158.8,141.2,141.9,158.1,121,158.1z"/>
                                    <path className="st0" d="M167.8,240.2H72.1c-39.7,0-72-32.3-72-72V72.5c0-39.7,32.3-72,72-72h95.7c39.7,0,72,32.3,72,72v95.7
                                        C239.8,207.9,207.6,240.1,167.8,240.2z M72.1,23c-27.3,0-49.4,22.2-49.4,49.5v95.7c0,27.3,22.1,49.4,49.4,49.4h95.7
                                        c27.3,0,49.4-22.1,49.4-49.4V72.5c0-27.3-22.1-49.4-49.4-49.5H72.1z"/>
                                </svg>
                            </a>
                            {/* <a href='https://www.facebook.com/luxinlux.face/' className="icon" target="_blank">
                                <svg id="Layer_1" style={{width: '50%', margin: 'auto'}} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 240">
                                    <title>facebook</title>
                                    <path className="cls-1" d="M120.26,134.83l6.66-43.38H85.3V63.3c0-11.87,5.81-23.44,24.45-23.44h18.93V2.93A231,231,0,0,0,95.08,0C60.8,0,38.4,20.78,38.4,58.39V91.45H.3v43.38H38.4V239.69H85.3V134.83Z"/>
                                </svg>
                            </a> */}
                            <a href='https://www.youtube.com/@luxinlux20' className="icon" target="_blank">
                                <svg version="1.1" style={{width: '100%', margin: 'auto'}} baseProfile="basic" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 244 170">
                                    <title>youtube</title>
                                    <path className="st0" d="M243.6,53.4c0-29.5-23.9-53.4-53.4-53.4H53.5C24,0,0.1,23.9,0.1,53.4V117c0,29.5,23.9,53.5,53.4,53.5
                                        c0,0,0,0,0,0h136.7c29.5,0,53.4-23.9,53.4-53.4c0,0,0,0,0,0V53.4z M163.2,90L102,120.3c-2.4,1.3-10.6-0.4-10.6-3.2V54.9
                                        c0-2.8,8.2-4.5,10.6-3.1l58.7,31.9C163.1,85.1,165.7,88.7,163.2,90z"/>
                                </svg>
                            </a>
                            
                                
                            <a href='https://www.linkedin.com/in/luxinlux/' className="icon" target="_blank">
                                <svg id="Layer_1" style={{width: '90%', margin: 'auto'}}  data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 215.73 215.73">
                                    <title>linkedin</title>
                                    <path className="cls-1" d="M5.54,71.37H50.2V214.91H5.54ZM27.88,0A25.87,25.87,0,1,1,2,25.86,25.87,25.87,0,0,1,27.88,0M78.2,214.91h44.56v-71c0-18.73,3.54-36.86,26.75-36.86,22.87,0,23.2,21.42,23.2,38.07v69.8h44.56V136.17c0-38.66-8.35-68.38-53.48-68.38-21.71,0-36.27,11.9-42.22,23.19H121V71.37H78.2Z"/>
                                </svg>
                            </a>
                            <a href = "tel: 02188147559" className="icon">
                                <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                    <title>call</title>
                                    <path d="M12.488 14.2427C13.7391 16.4406 15.5594 18.2609 17.7573 19.512L18.936 17.8613C19.1255 17.5959 19.4058 17.4092 19.7237 17.3364C20.0417 17.2637 20.3752 17.31 20.6613 17.4667C22.5471 18.4972 24.6296 19.117 26.772 19.2853C27.1064 19.3118 27.4185 19.4634 27.6461 19.7098C27.8737 19.9561 28 20.2793 28 20.6147V26.564C28.0001 26.8941 27.8777 27.2125 27.6565 27.4576C27.4353 27.7027 27.1311 27.857 26.8027 27.8907C26.096 27.964 25.384 28 24.6667 28C13.2533 28 4 18.7467 4 7.33333C4 6.616 4.036 5.904 4.10933 5.19733C4.14301 4.86893 4.29731 4.56469 4.54239 4.34351C4.78746 4.12233 5.10587 3.99993 5.436 4H11.3853C11.7207 3.99996 12.0439 4.12634 12.2902 4.35393C12.5366 4.58153 12.6882 4.89363 12.7147 5.228C12.883 7.37039 13.5028 9.45291 14.5333 11.3387C14.69 11.6248 14.7363 11.9583 14.6636 12.2763C14.5908 12.5942 14.4041 12.8745 14.1387 13.064L12.488 14.2427ZM9.12533 13.3667L11.6587 11.5573C10.9397 10.0055 10.4471 8.35845 10.196 6.66667H6.68C6.672 6.888 6.668 7.11067 6.668 7.33333C6.66667 17.2747 14.7253 25.3333 24.6667 25.3333C24.8893 25.3333 25.112 25.3293 25.3333 25.32V21.804C23.6415 21.5529 21.9945 21.0603 20.4427 20.3413L18.6333 22.8747C17.9049 22.5916 17.1973 22.2575 16.516 21.8747L16.4387 21.8307C13.8234 20.3423 11.6577 18.1766 10.1693 15.5613L10.1253 15.484C9.74254 14.8027 9.40838 14.0951 9.12533 13.3667Z" fill="#818796"/>
                                </svg>
                            </a>

                            {/* <a href='https://www.aparat.com/luxinlux' className="icon" target="_blank">
                                <svg id="Layer_1"  style={{width: '90%', margin: 'auto'}} viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg" >
                                    <title>aparat</title>
                                    <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
                                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
                                    <g id="SVGRepo_iconCarrier">
                                    <path d="M12.001 1.594c-9.27-.003-13.913 11.203-7.36 17.758a10.403 10.403 0 0 0 17.76-7.355c0-5.744-4.655-10.401-10.4-10.403zM6.11 6.783c.501-2.598 3.893-3.294 5.376-1.103 1.483 2.19-.422 5.082-3.02 4.582A2.97 2.97 0 0 1 6.11 6.783zm4.322 8.988c-.504 2.597-3.897 3.288-5.377 1.096-1.48-2.192.427-5.08 3.025-4.579a2.97 2.97 0 0 1 2.352 3.483zm1.26-2.405c-1.152-.223-1.462-1.727-.491-2.387.97-.66 2.256.18 2.04 1.334a1.32 1.32 0 0 1-1.548 1.053zm6.198 3.838c-.501 2.598-3.893 3.293-5.376 1.103-1.484-2.191.421-5.082 3.02-4.583a2.97 2.97 0 0 1 2.356 3.48zm-1.967-5.502c-2.598-.501-3.293-3.896-1.102-5.38 2.19-1.483 5.081.422 4.582 3.02a2.97 2.97 0 0 1-3.48 2.36zM13.59 23.264l2.264.61a3.715 3.715 0 0 0 4.543-2.636l.64-2.402a11.383 11.383 0 0 1-7.448 4.428zm7.643-19.665L18.87 2.97a11.376 11.376 0 0 1 4.354 7.62l.65-2.459A3.715 3.715 0 0 0 21.231 3.6zM.672 13.809l-.541 2.04a3.715 3.715 0 0 0 2.636 4.543l2.107.562a11.38 11.38 0 0 1-4.203-7.145zM10.357.702 8.15.126a3.715 3.715 0 0 0-4.547 2.637l-.551 2.082A11.376 11.376 0 0 1 10.358.702z"/>
                                    </g>

                                </svg>
                            </a> */}
                            {/* <a href='https://twitter.com/luxinlux20' className="icon" target="_blank">
                                <svg id="Layer_1"  style={{width: '90%', margin: 'auto'}} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 215.73 215.73">
                                    <title>twitter</title>
                                    <path className="cls-1" d="M67.85,214.29c81.41,0,125.93-67.45,125.93-125.94,0-1.91,0-3.82-.13-5.72a89.61,89.61,0,0,0,22.08-22.92,88.3,88.3,0,0,1-25.41,7A44.46,44.46,0,0,0,209.78,42.2a88.52,88.52,0,0,1-28.1,10.74A44.3,44.3,0,0,0,106.25,93.3,125.62,125.62,0,0,1,15,47.06a44.28,44.28,0,0,0,13.7,59.09,43.91,43.91,0,0,1-20-5.54c0,.19,0,.38,0,.57a44.28,44.28,0,0,0,35.51,43.39,44.5,44.5,0,0,1-20,.76,44.33,44.33,0,0,0,41.35,30.74,88.81,88.81,0,0,1-55,19A92,92,0,0,1,0,194.41a125.32,125.32,0,0,0,67.85,19.88"/>
                                </svg>
                            </a> */}
                        </div>
                        <div className="bottom-container container">
                            <div className="enamad">
                                    {/* eslint-disable */}
                                <a referrerPolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=316755&amp;Code=l2OpzRrnLXs24hv0lDf9"><img referrerPolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=316755&amp;Code=l2OpzRrnLXs24hv0lDf9" alt="" style={{cursor:'pointer'}} id="l2OpzRrnLXs24hv0lDf9"/></a>
                            </div>
                            <div className='copyright'>
                                {Lang.Footer.copyRight}
                            </div>
                            <div className="samandehi">
                                    <img referrerPolicy='origin' id ='rgvjwlaojxlzjzpeesgtfukz' style ={{cursor:'pointer'}} onClick={() => window.open("https://logo.samandehi.ir/Verify.aspx?id=341706&p=xlaoaodsrfthjyoeobpdgvka", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")} alt='logo-samandehi' src='https://logo.samandehi.ir/logo.aspx?id=341706&p=qftishwlnbpdyndtlymawlbq'/>
                                </div>
                        </div>
                    </div>
                    {/* <div className='media-footer-mo'>
                        <a href='https://www.instagram.com/luxinlux20/' className="icon" target="_blank" >
                            <svg version="1.1" style={{width: '80%', margin: 'auto'}} baseProfile="basic" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 240 240">
                                <title>instagram</title>
                                <path className="st0" d="M183.4,43.3c-7.7,0-14,6.3-14,14s6.3,14,14,14s14-6.3,14-14S191.2,43.3,183.4,43.3z"/>
                                <path className="st0" d="M121,61.3c-32.6,0-59,26.4-59,59s26.4,59,59,59s59-26.4,59-59C179.9,87.7,153.6,61.4,121,61.3z M121,158.1
                                    c-20.9,0-37.8-16.9-37.8-37.8s16.9-37.8,37.8-37.8s37.8,16.9,37.8,37.8v0C158.8,141.2,141.9,158.1,121,158.1z"/>
                                <path className="st0" d="M167.8,240.2H72.1c-39.7,0-72-32.3-72-72V72.5c0-39.7,32.3-72,72-72h95.7c39.7,0,72,32.3,72,72v95.7
                                    C239.8,207.9,207.6,240.1,167.8,240.2z M72.1,23c-27.3,0-49.4,22.2-49.4,49.5v95.7c0,27.3,22.1,49.4,49.4,49.4h95.7
                                    c27.3,0,49.4-22.1,49.4-49.4V72.5c0-27.3-22.1-49.4-49.4-49.5H72.1z"/>
                            </svg>
                        </a>
                        <a href='https://www.facebook.com/luxinlux.face/' className="icon" target="_blank">
                            <svg id="Layer_1" style={{width: '50%', margin: 'auto'}} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 240">
                                <title>facebook</title>
                                <path className="cls-1" d="M120.26,134.83l6.66-43.38H85.3V63.3c0-11.87,5.81-23.44,24.45-23.44h18.93V2.93A231,231,0,0,0,95.08,0C60.8,0,38.4,20.78,38.4,58.39V91.45H.3v43.38H38.4V239.69H85.3V134.83Z"/>
                            </svg>
                        </a>
                        <a href='https://www.youtube.com/@luxinlux20' className="icon" target="_blank">
                            <svg version="1.1" style={{width: '100%', margin: 'auto'}} baseProfile="basic" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 244 170">
                                <title>youtube</title>
                                <path className="st0" d="M243.6,53.4c0-29.5-23.9-53.4-53.4-53.4H53.5C24,0,0.1,23.9,0.1,53.4V117c0,29.5,23.9,53.5,53.4,53.5
                                    c0,0,0,0,0,0h136.7c29.5,0,53.4-23.9,53.4-53.4c0,0,0,0,0,0V53.4z M163.2,90L102,120.3c-2.4,1.3-10.6-0.4-10.6-3.2V54.9
                                    c0-2.8,8.2-4.5,10.6-3.1l58.7,31.9C163.1,85.1,165.7,88.7,163.2,90z"/>
                            </svg>
                        </a>
                        <a href='https://www.linkedin.com/in/luxinlux/' className="icon" target="_blank">
                            <svg id="Layer_1" style={{width: '90%', margin: 'auto'}}  data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 215.73 215.73">
                                <title>linkedin</title>
                                <path className="cls-1" d="M5.54,71.37H50.2V214.91H5.54ZM27.88,0A25.87,25.87,0,1,1,2,25.86,25.87,25.87,0,0,1,27.88,0M78.2,214.91h44.56v-71c0-18.73,3.54-36.86,26.75-36.86,22.87,0,23.2,21.42,23.2,38.07v69.8h44.56V136.17c0-38.66-8.35-68.38-53.48-68.38-21.71,0-36.27,11.9-42.22,23.19H121V71.37H78.2Z"/>
                            </svg>
                        </a>
                        <a href='https://www.aparat.com/luxinlux' className="icon" target="_blank">
                            <svg id="Layer_1"  style={{width: '90%', margin: 'auto'}} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 215.73 215.73">
                                
                                <path className="cls-1" d="M25.09,124.61c2.83,1.16,5.37,0,6.2-3.09.56-2.17,1.92-7.65,2.52-9.94.84-3.11.51-4.19-1.78-6.89-5-5.88-8.17-13.5-8.17-24.28,0-31.29,23.4-59.29,61-59.29,33.24,0,51.5,20.31,51.5,47.44,0,35.69-15.79,65.81-39.24,65.81-13,0-22.65-10.7-19.54-23.83,3.73-15.69,10.93-32.61,10.93-43.93C88.46,56.47,83,48,71.76,48c-13.24,0-23.87,13.7-23.87,32a47.64,47.64,0,0,0,4,19.59L35.92,167.1c-4.74,20-.72,44.56-.37,47a1.65,1.65,0,0,0,2.94.72c1.22-1.6,17-21.07,22.34-40.52,1.52-5.5,8.72-34,8.72-34,4.29,8.21,16.87,15.42,30.23,15.42,39.8,0,66.79-36.27,66.79-84.83C166.57,34.2,135.48,0,88.21,0,29.39,0-.26,42.17-.26,77.33-.26,98.62,7.8,117.56,25.09,124.61Z"/>
                            </svg>

                            <svg fill="#ffffff"  id="Layer_1"  style={{width: '90%', margin: 'auto'}} viewBox="0 0 24 24" role="img" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff">
                                <title>aparat</title>
                                <g id="SVGRepo_bgCarrier" strokeWidth="0"/>
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"/>
                                <g id="SVGRepo_iconCarrier">
                                <path d="M12.001 1.594c-9.27-.003-13.913 11.203-7.36 17.758a10.403 10.403 0 0 0 17.76-7.355c0-5.744-4.655-10.401-10.4-10.403zM6.11 6.783c.501-2.598 3.893-3.294 5.376-1.103 1.483 2.19-.422 5.082-3.02 4.582A2.97 2.97 0 0 1 6.11 6.783zm4.322 8.988c-.504 2.597-3.897 3.288-5.377 1.096-1.48-2.192.427-5.08 3.025-4.579a2.97 2.97 0 0 1 2.352 3.483zm1.26-2.405c-1.152-.223-1.462-1.727-.491-2.387.97-.66 2.256.18 2.04 1.334a1.32 1.32 0 0 1-1.548 1.053zm6.198 3.838c-.501 2.598-3.893 3.293-5.376 1.103-1.484-2.191.421-5.082 3.02-4.583a2.97 2.97 0 0 1 2.356 3.48zm-1.967-5.502c-2.598-.501-3.293-3.896-1.102-5.38 2.19-1.483 5.081.422 4.582 3.02a2.97 2.97 0 0 1-3.48 2.36zM13.59 23.264l2.264.61a3.715 3.715 0 0 0 4.543-2.636l.64-2.402a11.383 11.383 0 0 1-7.448 4.428zm7.643-19.665L18.87 2.97a11.376 11.376 0 0 1 4.354 7.62l.65-2.459A3.715 3.715 0 0 0 21.231 3.6zM.672 13.809l-.541 2.04a3.715 3.715 0 0 0 2.636 4.543l2.107.562a11.38 11.38 0 0 1-4.203-7.145zM10.357.702 8.15.126a3.715 3.715 0 0 0-4.547 2.637l-.551 2.082A11.376 11.376 0 0 1 10.358.702z"/>
                                </g>

                            </svg>
                        </a>
                        <a href='https://twitter.com/luxinlux20' className="icon" target="_blank">
                            <svg id="Layer_1"  style={{width: '90%', margin: 'auto'}} data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 215.73 215.73">
                                <title>twitter</title>
                                <path className="cls-1" d="M67.85,214.29c81.41,0,125.93-67.45,125.93-125.94,0-1.91,0-3.82-.13-5.72a89.61,89.61,0,0,0,22.08-22.92,88.3,88.3,0,0,1-25.41,7A44.46,44.46,0,0,0,209.78,42.2a88.52,88.52,0,0,1-28.1,10.74A44.3,44.3,0,0,0,106.25,93.3,125.62,125.62,0,0,1,15,47.06a44.28,44.28,0,0,0,13.7,59.09,43.91,43.91,0,0,1-20-5.54c0,.19,0,.38,0,.57a44.28,44.28,0,0,0,35.51,43.39,44.5,44.5,0,0,1-20,.76,44.33,44.33,0,0,0,41.35,30.74,88.81,88.81,0,0,1-55,19A92,92,0,0,1,0,194.41a125.32,125.32,0,0,0,67.85,19.88"/>
                            </svg>
                        </a>
                    </div> */}
                    {/* {this.butoomFooter()} */}
                </div>
            </Styles>
        )
    }
}
export default Footer;